import { Outlet } from 'react-router-dom';
import { Hidden } from '@mui/material';
import MainLayout from '../MainLayout';
import SecondaryTopBar from '../MainLayout/SecondaryTopBar';

function NonCaseLayout() {
  return (
    <MainLayout>
      <Hidden lgDown>
        <SecondaryTopBar />
      </Hidden>
      <div style={{ overflow: 'auto', height: '100%' }}>
        <Outlet />
      </div>
    </MainLayout>
  );
}

export default NonCaseLayout;
